import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import "./styles.css";
import "./ops-chat-compact.css";
import "./readability.css";
import "./desk.css";
import "./workspace-chrome.css";
import "./ops-surfaces-visual.css";
import "./work-visual.css";
import "./calendar-visual.css";
import "./proof-typography.css";
import "./shell-spacing.css";
import "./timeline-spacing.css";
import "./settings-visual.css";

const root = document.getElementById("root");
if (!root) throw new Error("Application root was not found.");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);

import "./premium-refinement.css";
import "./app-premium.css";
import "./app-composer-compact.css";
import "./app-workspace-layout.css";
import "./sidebar-rail.css";
